import { useMutation } from "@tanstack/react-query";
import { sendLegacyPushNotification } from "../../../services/push-notifications";

const useLegacyPushNotification = () =>
  useMutation({ mutationFn: sendLegacyPushNotification });

export default useLegacyPushNotification;
